<template>
  <div class="quotas" v-if="quota">
    <div class="quotas__wrap">
      <PlanQuotaItem
        v-for="(quotaItem,itemType) in quota"
        :quota="quotaItem"
        :item-type="itemType"
        :key="itemType"
      />
    </div>
  </div>
</template>

<script>
import PlanQuotaItem from '@/components/Payment/Plans/PlanQuotaItem';
import useAccount from '@/compositions/accounting/useAccount';

export default {
  name: 'PlanQuotaItems',
  components: { PlanQuotaItem },
  setup() {
    const { quota, plan } = useAccount();

    return {
      quota,
    };
  },
};
</script>

<style lang="scss" scoped>
.quotas {
  &__wrap {
    display: flex;
    justify-content: space-between;
    max-width: 27.5rem;
    margin: 0 auto;
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .quotas__wrap {
    max-width: 22rem;
  }
}
</style>
